import React from "react";
import {VTextContainer} from "./VText.style";

export const VText = ({children, ...props}: VTextProps) => {
    return <VTextContainer {...props}>{children}</VTextContainer>;
};
